const wait = (ms) => new Promise(res => setTimeout(res, ms))
export default wait